<template>
  <div style="height:100%">
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      :header-cell-style="textStyle"
      :cell-style="textStyle"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="index" label="序号" width="100">
        <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
      </el-table-column>
      <el-table-column prop="fileName" label="资料名称"></el-table-column>
      <el-table-column prop="address" label="操作" width="400" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small" style="font-size:14px">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pdf-view :dialogVisible="dialogVisible" @closeDialog="closeDialog" :path="path"></pdf-view>
  </div>
</template>

<script>
import { townServiceList, downloadTownInfo } from "common/js/api";
// import pdf from "vue-pdf";
import PdfView from "./pdfView";

export default {
  name: "Download",

  components: {
    PdfView
  },

  data() {
    return {
      textStyle: {
        "text-align": "center"
      },
      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      path: ""
    };
  },

  mounted() {
    this.getDownload();
  },

  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },

    async getDownload() {
      const name = "TOWN_SERVICE";
      const { result } = await townServiceList(name);
      this.tableData = result;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleClick(row) {

      // this.dialogVisible = true;
      this.download(row.id);
    },

    async download(id) {
      await downloadTownInfo(id);
    }
  }
};
</script>

<style scoped>
.pdf {
  height: 1000px;
}
</style>
